import * as yup from 'yup';
import { SimplifiedHero } from '@web/components';
import {
  headlineVariantsSchema,
  linkSchema,
  richTextFromCMSSchema,
} from '../schemas';
import { schema as ctaGroupSchema } from './cta_group';

export const component = SimplifiedHero;

export const schema = yup
  .object({
    heading: yup.string(),
    // SimplifiedHero has the level passed down to the SectionIntro component so we don't need the when block here
    headingVariants: headlineVariantsSchema(),
    description: richTextFromCMSSchema,
    link: yup.lazy(item => {
      switch (item?.component) {
        case 'cta_group':
          return ctaGroupSchema;
        default:
          return linkSchema;
      }
    }),
    backgroundColor: yup.string(),
    level: yup.string(),
    eyebrow: yup.string(),
    typography: yup.string(),
    fontColor: yup.string(),
    mobilePadding: yup.number().nullable(),
    desktopPadding: yup.number().nullable(),
    textAlignment: yup.string().oneOf(['left', 'center', 'right']),
  })
  .transform(value => ({
    heading: value.heading,
    headingVariants: value.headline_variants,
    description: value.description,
    link: value.link?.[0],
    backgroundColor: value.backgroundColor || undefined,
    level: value.level,
    eyebrow: value.eyebrow,
    typography: value.typography || 'heading2',
    fontColor: value.font_color || undefined,
    mobilePadding: value.mobile_padding || null,
    desktopPadding: value.desktop_padding || null,
    textAlignment: value.text_alignment || undefined,
  }));
